import { FormSection, FormRow, BigFormRow, MediumFormRow } from 'framework/ui/layout';
import { TextInput, CountryDropdown, TextArea, PhoneInput, InputList } from 'framework/form';
import AccountInput from 'domain/finance/ledger/shared/input/AccountInput';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';
import VendorDocumentContextTemplate from 'domain/finance/vendors/VendorTabs/vendorDocuments/VendorDocumentContextTemplate';
import { OneStopPageLayout } from 'domain/shared/oneStop';
import useVendorService from 'domain/finance/vendors/useVendorService';
import ContactVendorsInputs from 'domain/finance/vendors/shared/inputs/VendorContactsInput/VendorsContactInputs';
import { OneStopCreateForm, useOneStopRequestsUrl } from 'domain/shared/oneStop';

type OneStopCreateVendorPageProps = {
  requestId?: string;
};

const OneStopCreateVendorPage = ({ requestId = 'CREATE_VENDOR' }: OneStopCreateVendorPageProps) => {
  const { create, createVendorValidationSchema, searchVendorCostCentersAccounts } = useVendorService();
  const { getListUrl: getOneStopListUrl } = useOneStopRequestsUrl();

  return (
    <VendorDocumentContextTemplate>
      <OneStopCreateForm
        requestId={requestId}
        submitFormFunc={create}
        afterSubmit={{
          redirect: getOneStopListUrl(),
          message: 'You are awesome! The Vendor has been successfully created.',
        }}
        getValidationSchemaFunc={createVendorValidationSchema}
        initialData={{
          contacts: [],
        }}
      >
        <OneStopPageLayout>
          <FormSection title="">
            <FormRow>
              <TextInput source="vendorName" label="" placeholder="Vendor name" />
              <CountryDropdown label="" placeholder="Vendor country" source="country" />
              <TextInput label="" placeholder="Tax registration number" source="taxRegistrationNumber" />
              <AccountInput
                source="costCenterId"
                label=""
                placeholder="Cost center"
                cacheKey="vendor-accounts"
                loadDataMethod={searchVendorCostCentersAccounts}
              />
            </FormRow>

            <BigFormRow>
              <TextArea source="purpose" placeholder="Purpose" label="" />
            </BigFormRow>

            <FormRow>
              <TextInput source="expectedCollaborationPeriod" label="" placeholder="Expected collaboration period" />
            </FormRow>
          </FormSection>

          <MediumFormRow>
            <FormSection title="Vendor agreement">
              <BigFormRow>
                <TextInput source="publicOfferLink" label="" placeholder="Public offer link" />
                <NoteAttachmentUploaderInput isNewDocumentStorage source="contractDraft" label="Contract draft" />
              </BigFormRow>
            </FormSection>
            <FormSection title="Contacts">
              <BigFormRow>
                <MediumFormRow>
                  <PhoneInput label="" placeholder="General vendor phone" source="phoneNumber" />
                  <TextInput label="" placeholder="General vendor email" source="email" />
                </MediumFormRow>

                <InputList
                  defaultValue={{
                    name: '',
                    phoneNumber: '',
                    email: '',
                  }}
                  maxFields={3}
                  inputTemplate={ContactVendorsInputs}
                  source="contacts"
                />
              </BigFormRow>
            </FormSection>
          </MediumFormRow>
        </OneStopPageLayout>
      </OneStopCreateForm>
    </VendorDocumentContextTemplate>
  );
};

export default OneStopCreateVendorPage;
